import script from "./DropdownUsuarios.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownUsuarios.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownUsuarios.vue?vue&type=style&index=0&id=5c3aa10b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c3aa10b"]])

export default __exports__